import { Typography, TypographyProps } from '@mui/material';
import clsx from 'clsx';
import { DetailedHTMLProps, HTMLAttributes, ReactNode } from 'react';

import { OptionalWrapper } from '..';

import styles from './FilledSection.module.scss';


export interface FilledSectionProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    className?: string;
    header?: ReactNode;
    footer?: ReactNode;
    headerTypographyProps?: TypographyProps;
    variant?: 'light' | 'dark';
    classes?: {
        header?: string;
    };
    noResultsMessage?: ReactNode;
    scrollable?: boolean;
}

export function FilledSection({
    children, className, header, footer, headerTypographyProps, variant, classes, noResultsMessage, scrollable, ...props
}: FilledSectionProps) {
    return (
        <div
            className={clsx(styles.root, className, {
                [styles.scrollable]: scrollable,
                [styles.light]: variant === 'light'
            })}
            {...props}
        >
            {header ? (
                <Typography
                    {...headerTypographyProps}
                    className={clsx(styles.header, classes?.header, headerTypographyProps?.className)}
                >
                    {header}
                </Typography>
            ) : <div />}

            <OptionalWrapper
                renderWrapper={!!scrollable}
                Component={Div}
                className={styles.content}
            >
                {children}
            </OptionalWrapper>

            <Typography
                className={styles.noResultsMessage}
                variant="body2"
                color="textSecondary"
                align="center"
            >
                {noResultsMessage}
            </Typography>

            {footer}
        </div>
    );
}

FilledSection.defaultProps = {
    variant: 'dark',
    headerTypographyProps: {
        variant: 'h6'
    }
} as FilledSectionProps;

function Div(props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) {
    return <div {...props} />;
}
